// extracted by mini-css-extract-plugin
export default {"brand-tile":"BrandTile_brand-tile__WxsZA","brand-image":"BrandTile_brand-image__7WzkO","brand-name":"BrandTile_brand-name__OHCsZ"};